const COHORT_KEY = 'user_cohort';
const SEARCHES_KEY = 'user_searches';
class UserStore {
	cohort: string | null;
	searches: string[] = [];
	constructor() {
		this.cohort = this.getCohort();
		this.searches = this.getSearches();
	}

	getCohort() {
		const cohort = localStorage.getItem(COHORT_KEY);
		if (cohort) {
			this.cohort = cohort;
			return cohort;
		}
		return null;
	}

	setCohort(cohort: string) {
		localStorage.setItem(COHORT_KEY, cohort);
	}

	addSearch(rawSearch: string) {
		const search = rawSearch.trim();
		if (this.searches.some((s) => s.includes(search))) {
			return;
		}
		this.searches = this.searches.filter((s) => !(search.includes(s)));
		this.searches.unshift(search);
		this.searches = this.searches.slice(0, 5);
		localStorage.setItem(SEARCHES_KEY, JSON.stringify(this.searches));
	}

	removeSearch(search: string) {
		this.searches = this.searches.filter((s) => s !== search);
		localStorage.setItem(SEARCHES_KEY, JSON.stringify(this.searches));
	}

	getSearches() {
		if (this.searches.length) {
			return this.searches;
		}
		return this._getSearches();
	}

	_getSearches() {
		const searches = localStorage.getItem(SEARCHES_KEY);
		try {
			if (searches) {
				this.searches = JSON.parse(searches);
				return this.searches;
			}
		} catch (error) {
			localStorage.removeItem(SEARCHES_KEY);
			return [];
		}
		return [];
	}
}

export const userStore = new UserStore();